import { render, staticRenderFns } from "./EocVitalsV2.vue?vue&type=template&id=3fb82598&"
import script from "./EocVitalsV2.vue?vue&type=script&lang=js&"
export * from "./EocVitalsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports